import React from 'react';
import Message from 'Components/Modal/Message';
import EnvironmentManager from 'Utils/environmentManager';

const PostponedModal = () => {
  
  let coupons_match_postponed_status = EnvironmentManager.getMessageText({ key: 'coupons_match_postponed_status' });
  
  coupons_match_postponed_status = coupons_match_postponed_status.replace('İddaa Oyun Kuralları', '<a title="İddaa Oyun Kuralları" href="/yardim/yardim-konulari/iddaa">İddaa Oyun Kuralları</a>');
  
  const defaultText = "İlgili karşılaşma ertelenmiş ya da yarıda kalmıştır. Karşılaşma, 1 takvim günü içerisinde tekrar oynanmaz ise değerlendirmesi <a title='İddaa Oyun Kuralları' href='/yardim/yardim-konulari/iddaa'>İddaa Oyun Kuralları</a> çerçevesinde tamamlanacaktır. Takvim günü; karşılaşma için iddaa bülteninde belirtilen oynanma tarihinden sonraki gün saat 00:00'a kadar olan süreyi ifade etmektedir.";
  
  return (
    <Message type="none">
      <div className="postponed" dangerouslySetInnerHTML={ { __html: coupons_match_postponed_status ? coupons_match_postponed_status : defaultText } }/>
    </Message>
  );
};

export default PostponedModal;
